import React from 'react';
import { PARAMS } from "../../../../config";

const Head = ({ onSortChange }) => {
    let th = PARAMS.map(([ param, paramName ]) => <th onClick={() => onSortChange(param)} key={param}>{paramName}</th>);

    return (
        <thead>
            <tr>
                <th onClick={() => onSortChange(`n`)}>Network</th>
                <th onClick={() => onSortChange(`a`)}>Affid</th>
                <th onClick={() => onSortChange(`s`)}>Subid</th>
                {th}
            </tr>
        </thead>
    )
};

export default Head;


// WEBPACK FOOTER //
// ./src/scenes/AkFull/components/Table/components/Head/index.js